import { Fragment } from 'react'
import { useParams, Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Box, Typography } from '@mui/material'
import { PageTitle } from '../components/atoms/PageTitle'

const CHECK_TYPES = [
  'battery_soc_zero',
  'energy_meter_to_summer',
  'inverter_connection',
  'inverter_obedience',
  'multiopt_link',
]

export function DiagnosticHelpPage(): React.ReactElement {
  const { checkType } = useParams()
  const { t } = useTranslation()

  // Index page — list all check types.
  if (!checkType) {
    return (
      <Fragment>
        <PageTitle title={t('Diag-help-title')} />
        <Box sx={{ mt: 2 }}>
          {CHECK_TYPES.map((ct) => (
            <Box key={ct} sx={{ mb: 2 }}>
              <Link to={`/help/diagnostics/${ct}`} style={{ color: '#90caf9' }}>
                {t(`Diag-help-${ct}-title`)}
              </Link>
            </Box>
          ))}
        </Box>
      </Fragment>
    )
  }

  const titleKey = `Diag-help-${checkType}-title`
  const bodyKey = `Diag-help-${checkType}-body`
  const title = t(titleKey)
  const body = t(bodyKey)

  // Unknown check type.
  if (title === titleKey) {
    return (
      <Fragment>
        <PageTitle title={t('Diag-help-title')} />
        <Typography sx={{ mt: 2 }} color="text.secondary">
          {t('Diag-help-not-found')}
        </Typography>
      </Fragment>
    )
  }

  return (
    <Fragment>
      <PageTitle title={title} />
      <Box sx={{ mt: 2 }}>
        <Typography
          variant="body1"
          sx={{ whiteSpace: 'pre-line', lineHeight: 1.8 }}
          dangerouslySetInnerHTML={{ __html: body }}
        />
      </Box>
      <Box sx={{ mt: 4 }}>
        <Link to="/help/diagnostics" style={{ color: '#90caf9' }}>
          &larr; {t('Diag-help-title')}
        </Link>
      </Box>
    </Fragment>
  )
}
